<template>
  <a-badge v-bind="attrs" :class="bem.b()">
    <template
      v-for="item in Object.keys($slots).filter((key) => key !== 'count')"
      #[item]="data"
    >
      <slot :name="item" v-bind="data || {}"></slot>
    </template>

    <template
      v-if="$slots.count || (props.icon && props.icon?.iconName)"
      #count
    >
      <slot name="count">
        <ll-icon v-bind="props.icon" />
      </slot>
    </template>
  </a-badge>
</template>

<script lang="ts" setup>
import { createNamespace } from '@ll-plus/utils'
import { useAttrs } from 'vue'
import { badgeProps } from './badge'

defineOptions({
  name: 'LlBadge',
})
const attrs = useAttrs()
const props = defineProps(badgeProps)

const bem = createNamespace('badge')
</script>
